import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAi'

export const ugcPersonasList = (params = '') => Http.get(`/admin/ugc-personas${serialize(params)}`)
export const ugcPersonaCreate = (params = '') => Http.post('/admin/ugc-personas', params)
export const ugcPersonaByID = (params = '') => Http.get(`/admin/ugc-personas${params}`)
export const ugcPersonaUpdate = (params = '') => Http.put(`/admin/ugc-personas/${params.id}`, params)
export const ugcPersonaDestroy = (params = '') => Http.delete(`/admin/ugc-personas/${params.id}`)
